import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { usePropertyFilters } from '../../hooks/usePropertyFilters';

interface QuickSearchOptionsProps {
  onQuickSearch: (filters: any) => void;
  contractType: string;
  isMobile?: boolean;
}

const QuickSearchOptions: React.FC<QuickSearchOptionsProps> = ({ 
  onQuickSearch, 
  contractType,
  isMobile = false 
}) => {
  const { filters } = usePropertyFilters();

  // Get the most populated zones and property types
  const popularZones = [...filters.zones]
    .sort((a, b) => (b.count || 0) - (a.count || 0))
    .slice(0, 2);

  const popularTypes = [...filters.propertyTypes]
    .sort((a, b) => (b.count || 0) - (a.count || 0))
    .slice(0, 2);

  // Dynamically generate quick search options based on actual data
  const quickSearchOptions = [
    // Most popular zone with specific rooms
    ...(popularZones[0] ? [{
      label: `${filters.totalRooms[1]?.label || '2-3 camere'} in ${popularZones[0].label}`,
      filters: {
        zone: popularZones[0].value,
        totalRooms: filters.totalRooms[1]?.value || '2-3'
      }
    }] : []),

    // Most popular property type
    ...(popularTypes[0] ? [{
      label: popularTypes[0].label,
      filters: {
        propertyType: popularTypes[0].value
      }
    }] : []),

    // Price-based options
    {
      label: 'Fino a €200.000',
      filters: {
        priceRange: 'vendita-0-200000'
      }
    },

    // Second most popular zone
    ...(popularZones[1] ? [{
      label: `Immobili in ${popularZones[1].label}`,
      filters: {
        zone: popularZones[1].value
      }
    }] : [])
  ].slice(0, 4); // Ensure we only show max 4 options

  return (
    <div className={`${isMobile ? 'flex flex-wrap justify-start' : 'flex items-center gap-6'}`}>
      {!isMobile && (
        <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
          Ricerche frequenti:
        </span>
      )}
      <div className="flex flex-wrap gap-2">
        {quickSearchOptions.map((option, index) => (
          <motion.button
            key={index}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => onQuickSearch(option.filters)}
            className={`px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-full text-sm font-medium text-gray-700 flex items-center transition-colors ${isMobile ? 'text-xs py-1' : ''}`}
          >
            <ArrowRight className="h-3 w-3 mr-1" />
            {option.label}
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default QuickSearchOptions;